var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['c-search-input__wrapper', _vm.styleModifier]},[_c('input',{staticClass:"c-search-input",attrs:{"type":"text","placeholder":_vm.placeholder,"name":_vm.name}}),_c('button',{staticClass:"c-search-input__submit",attrs:{"type":"submit"}},[_c('SearchIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }